import type { PropsWithChildren } from 'react'
import IzzyResultFailGif from '@/assets/images/izzy/result-fail.gif'
import { cn } from '@/lib/utils'
import { IzzySpeechBubble } from '../speech-bubble'

interface IzzyResultFailProps extends PropsWithChildren {
  className?: string
}

export const IzzyResultFail = ({
  className,
  children
}: IzzyResultFailProps) => {
  return (
    <div className={cn('select-none flex', className)}>
      <img
        src={IzzyResultFailGif}
        alt="Izzy Dizendo que conseguiu fazer as equivalências de disciplinas"
      />
      <div>
        <IzzySpeechBubble className="absolute w-80 left-40 top-[-80px]">
          {children}
        </IzzySpeechBubble>
      </div>
    </div>
  )
}
